<template>
    <div class="historyInfo">
      <div class="search">
        <div class="dataTime">
            <van-form>
                <van-row>
                    <van-cell title="查询开始时间：" is-link :value="beginTime" @click="clickBegin(beginTime)" />
                    <van-calendar ref="history" :value="beginTime" v-model="showBegin" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmBegin" />
                </van-row>
                <van-row>
                    <van-cell title="查询结束时间：" is-link :value="endTime" @click="showEnd = true" />
                    <van-calendar v-model="showEnd" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmEnd" />
                </van-row>
                <van-field
                    v-model="dataForm.idNo"
                    label="身份证号"
                    colon
                    label-align="center"
                    placeholder="身份证号"
                    maxlength="18"
                    minlength="18"
                />
                <van-field
                    v-model="dataForm.plateNo"
                    label="车牌号码"
                    colon
                    label-align="center"
                    placeholder="车牌号码"
                    maxlength="8"
                    minlength="7"
                />
                
                
                <div style="margin: 16px;">
                    <van-button round block type="info" @click="onSearch">查 询</van-button>
                    <span style="color: #fa8f04;font-weight: bold; font-size: 13px;float: right;margin:1% 5%;">{{ queryDataLength }}</span>
                </div>
            </van-form>
          <van-divider style="margin: 0;" />
        </div>
      </div>

      <div class="searchContent">
        <van-list
          :finished="finished"
          finished-text="没有更多了"
        >
          <van-cell v-for="item in responseDataArray" :key="item.id" >
            <van-row>
              <van-col :span="18">
                <van-row>
                  <van-col :span="8" style="text-align: right;">车牌号码：</van-col>
                  <van-col :span="16">{{ item.plateNo }}</van-col>
                </van-row>
                <van-row>
                  <van-col :span="8" style="text-align: right;">身份证号：</van-col>
                  <van-col :span="16">{{ item.idNo }}</van-col>
                </van-row>
              </van-col>
              <van-col :span="5">
                <!-- <van-button  plain hairline type="info" @click="showDetail(item)"
                 >编辑</van-button> -->
                <van-button  style="height: 42px;" plain hairline type="info" @click="showDetail(item)"
                 >{{ '查看' }}</van-button>
              </van-col>
            </van-row>
          </van-cell>
        </van-list>
      </div>
      <!-- 查看详情信息 -->
          <van-overlay :show="showDataDetail" @click="showDataDetail=false">
            <div class="wrapper" @click.stop>
              <div class="historyBlock">
                <div class="title">
                  <span>详情
                    <van-icon name="close" class="cancel" @click="cancelForm"/>
                  </span>
                </div>
                <van-cell title="用户姓名："  v-model="showList.name" style="text-align: left;"/>
                <van-cell title="身份证号："  v-model="showList.idNo" style="text-align: left;"/>
                <van-cell title="车牌号码："  v-model="showList.plateNo" style="text-align: left;"/>
                <van-cell title="存放位置：" v-model="showList.boxCode" style="text-align: left;"/>
                <van-cell title="操作类型：" v-model="showList.operateTypeContent" style="text-align: left;"/>
                <van-cell title="领取方式：" v-model="showList.selfGetTypeTypeContent" style="text-align: left;"/>
                <van-cell title="业务受理点：" v-model="showList.applyStation" style="text-align: left;"/>
                <van-cell title="号牌领取点：" v-model="showList.getStation" style="text-align: left;"/>
                <van-cell title="创建时间： " v-model="showList.createTime" style="text-align: left;"/>
                <div style="margin: 16px;">
                  <van-button round block type="info" @click="cancelForm">
                    确 定</van-button>
                </div>
              </div>
            </div>
          </van-overlay>
    </div>
  </template>
  
  <script>
  import {QueryHistory,QueryStationDic} from '@/my_js//HttpRequest.js'
  import {formatTime,formatDateTime,getNowTime,formatBeginTime,formatEndTime} from '@/utils/date.js'
  import { Notify } from 'vant'
  export default {
    filters:{
    },
    mounted(){
      const end = new Date()
      const start = new Date()
      end.setTime(start.getTime() - 3600 * 1000 * 24 * 30)//默认查询30天时间
      const data = formatDateTime(end)
      console.log(data);
      this.beginTime = data
      this.endTime = getNowTime()//当天时间

      // 获取服务站信息
      this.queryStationDic()

    },
    data(){
      return{
        dataForm:{
          plateNo:'冀A',//车牌号
          idNo:null,//身份证号
          dateBegin:null,//开始时间
          dateEnd:null,//结束时间
        },
        beginTime:null,
        endTime:null,
        searchValue:'',//搜索内容
        loading:false,
        finished:false,
        minDate:new Date(2020,0,1),
        maxDate:new Date(2050,12,31),
        showBegin:false,
        showEnd:false,
        responseDataArray:[],//响应数据
        showDataDetail:false,//详情显示
        showList:[],//详情信息列表
        stationDic:null,//服务站信息
        queryDataLength:null,//查询到的数据量
        
      }
    },
    methods:{
      // 返回
      goBack(){
        console.log('返回管理员首页');
        this.$router.push('/manager')
      },
      // 搜索
    onSearch(){
        this.loading = true
        console.log('dataForm',this.dataForm);
        // debugger
        const idNoLength = this.dataForm.idNo.length
        const plateNoLength = this.dataForm.plateNo.length
        if(this.dataForm.idNo === '' && plateNoLength <=2){
          this.dataForm.plateNo = '冀A'
          Notify({message:'请输入查询信息后再查询',type:'warning'})
        }else{
          // console.log('11111');
          if(this.dataForm.idNo != '' && idNoLength != 18){
            Notify({message:'请输入正确的身份证号后再查询',type:'warning'})
          }else if(plateNoLength > 2 && (plateNoLength != 7 && plateNoLength != 8)){
            Notify({message:'请输入正确的车牌号后再查询',type:'warning'})
          }else if(idNoLength == 18 || (plateNoLength == 7 || plateNoLength == 8) ){
            this.dataForm.dateBegin = formatBeginTime(this.beginTime)
            this.dataForm.dateEnd = formatEndTime(this.endTime)
            QueryHistory(this.dataForm).then(res => {
              console.log(res);
              this.responseDataArray = res.data
              console.log( 'this.responseDataArray',this.responseDataArray);
              this.finished = true
              if(this.responseDataArray.length == 0){
                  Notify({message:'暂无该车牌历史记录，请稍后再试',type:'warning'})
                  this.queryDataLength = null
              }else{
                this.queryDataLength = this.responseDataArray.length
              }
            
            })
          }
        }


        // if(this.dataForm.idNo != '' && this.dataForm.idNo.length != 18){
        //   Notify({message:'请输入正确的身份证号后再查询',type:'warning'})
        // }else if (this.dataForm.plateNo.length != '' && (this.dataForm.plateNo.length != 7 && this.dataForm.plateNo.length != 8)){
        //   Notify({message:'请输入正确的车牌号后再查询',type:'warning'})
        // }else if(this.dataForm.idNo.length == 18 || (this.dataForm.plateNo.length == 7 || this.dataForm.plateNo.length == 8)){
        //   this.dataForm.dateBegin = formatBeginTime(this.beginTime)
        //   this.dataForm.dateEnd = formatEndTime(this.endTime)
        //   QueryHistory(this.dataForm).then(res => {
        //     console.log(res);
        //     this.responseDataArray = res.data
        //     console.log( 'this.responseDataArray',this.responseDataArray);
        //     this.finished = true
        //     if(this.responseDataArray.length == 0){
        //         Notify({message:'暂无该车牌历史记录，请稍后再试',type:'warning'})
        //         this.queryDataLength = null
        //     }else{
        //       this.queryDataLength = this.responseDataArray.length
        //     }
           
        //   })
        // }else{
        //   Notify({message:'请输入查询信息后再查询',type:'warning'})
        // }
        
      },
      // 选择日期并格式化时间
      onConfirmBegin(date){
          this.showBegin = false
          // 格式化时间
          this.beginTime = formatDateTime(date)
          console.log('开始时间：',this.beginTime);
          // this.onSearch()
      },
      // 开始时间定位到 beginTime
      clickBegin(date){
        this.showBegin = true
        this.$nextTick(() => {
          this.$refs.history.reset(new Date(date))// 确保日历定位到指定时间
        })
      },
        // 选择日期并格式化时间
        onConfirmEnd(date){
        this.showEnd = false
        // 格式化时间
        this.endTime = formatDateTime(date)
        console.log('结束时间：',this.endTime);
        // this.onSearch()
        },
      // 关闭详情页面
      cancelForm(){
        this.dataForm.idNo = '',
        this.dataForm.plateNo = ''
        this.showDataDetail = false
      },
      // 查看详情信息
      showDetail(val){
        console.log(val);
        this.showList = val
        this.showList.createTime = formatTime(this.showList.createTime)
        // 业务受理点
        const filterApplyStation = this.stationDic.filter(item => item.code == val.applyStationCode)
        console.log('filterApplyStation',filterApplyStation);
        // this.showList.applyStation = filterApplyStation[0].name
        
        // 号牌领取点
        const filterGetStation = this.stationDic.filter(item => item.code == val.getStationCode)
        // this.showList.getStation = filterGetStation[0].name
        if(filterApplyStation.length != 0 && filterGetStation.length != 0){
          this.showList.applyStation = filterApplyStation[0].name
          this.showList.getStation = filterGetStation[0].name
        }
        // 是否为管理员代取，是用户姓名显示为管理员名字
        if(val.operateType == 3){
          this.showList.name = val.userName
        }else{
          this.showList.name = val.idName
        }
        this.showDataDetail = true
      },
       // 获取服务站信息
       queryStationDic(){
        // this.stationOption.push({text:'请选择服务站',value:0})
        QueryStationDic().then(res => {
          console.log(res);
          this.stationDic = res.data
          // this.stationDic.forEach(element => {
          //   this.stationOption.push({text:element.name,value:element.code,getStation:element.getStation})
          // });
          console.log('服务站信息:',this.stationDic);
        })
      },
  
    }
  
  }
  </script>
  
  <style lang="scss" >
  .historyInfo{
    .searchContent{
      .van-cell__title{
        line-height: 45px;
      }
    }
  
    .van-nav-bar__left{
      left: 0;
    }
    .van-nav-bar .van-icon{
      color: #0283ef;
    }
    .van-nav-bar__text{
      color: #0283ef;
    }
    .van-search__action{
      color: #0283ef;
      font-size: 18px;
    }
  
    .wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .historyBlock{
      width: 95%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
      .van-field__control{
        width: 90%;
      }
    }
    }
   
  
  }
  
  </style>